import { BiBorderRadius } from "react-icons/bi";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons";
export default {
  row1 : [
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "sezzInvSrNo",
          label: "SEZ-Z Inv Sr",
          component: "text-field",
          dataType:"int"
        },
        {
          name: "sezzItemSrNo",
          label: "SEZ-Z Item Sr",
          component: "text-field",
          dataType:"int"
        },
      ],
      row2: [
        {
          name: "sezBENo",
          label: "BE No",
          component: "dropdown",
          endIconName: "LuSearch",
          options: [
            { label: "123", value: "123" },
            { label: "897656", value: "8909877" },
            { label: "098987", value: "09876" },

          ],
          width:"50%"

        },
        {
          name: "sezBEDate",
          label: "BE Date",
          component: "dateselector",
          width:"50%"
        },
      ],
      row3: [
        {
          name: "sezBELocation",
          label: "BE Location",
          component: "text-field",
          endIconName: "LuSearch",
          type:"autocomplete",
          endpoint:"getPorts",
          useParams : "general.exportTransportMode",
          endpointWithParams : "portType",
        },
        {
          name: "sezCode",
          label: "Code",
          component: "dropdown",
          endIconName: "LuSearch",
          options: [
            { label: "123", value: "123" },
            { label: "897656", value: "8909877" },
            { label: "098987", value: "09876" },

          ]

        },
      ],
      row4: [
        {
          name: "sezQuantity",
          label: "Quantity",
          component: "text-field",
          icon: LuSearch,
          iconColor: "gray-400",
          dataType:"float"
        },
        {
          name: "sezUnit",
          label: "Unit",
          component: "text-field",
          type:"autocomplete",
          endpoint:"getQuantity"

        },
      ],
    },
  },
]
};
